import {
  apiGet,
  apiDelete,
  apiPost,
  apiPatch,
} from "../../../utils";

export const getMessageAPI = (data) => {
  return apiGet(`/api/message/${data.id}`);
};

export const sendMessageAPI = (data) => {
  return apiPost("/api/message", data);
};

export const replyMessageAPI = (params, data) => {
  return apiPost(`/api/message/reply/${params.id}`, data);
};

export const updateMessageAPI = (params, data) => {
  return apiPatch(`/api/message/${params.id}`, data);
};

export const updateMessageReplyReadAPI = (params) => {
  return apiPatch(`/api/message/markReplyAsRead/${params.messageId}/${params.replyId}`);
};

export const deleteMessageAPI = (id) => {
  return apiDelete(`/api/message/${id}`);
};